import { blockCategories } from '../categories';

export default (editor) => {
    const domComponents = editor.DomComponents;

    editor.BlockManager.add('hover-container', {
        content: {
            type: 'hover-container',
            classes: ['hover-container'],
        },
        label: 'Hover-Block',
        category: blockCategories.advance,
        media: `<svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
  </svg>`,
    });

    const defaultType = domComponents.getType('default');
    const defaultModel = defaultType.model;
    const defaultView = defaultType.view;

    domComponents.addType('hover-container', {
        model: {
            defaults: Object.assign({}, defaultModel.prototype.defaults, {
                'custom-name': 'Hover',
                tagName: 'div',
                droppable: true,
                traits: [
                    {
                        type: 'select',
                        label: 'Dropdown Direction',
                        name: 'dropdown-direction',
                        options: [
                            { value: 'bottom', name: 'Bottom' },
                            { value: 'right', name: 'Right' },
                            { value: 'left', name: 'Left' },
                            { value: 'top', name: 'Top' },
                        ],
                        changeProp: 1,
                        default: "bottom",
                    },
                ],
            }),
        },
        isComponent(el) {
            if (
                el &&
                el.classList &&
                el.classList.contains('hover-container')
            ) {
                return { type: 'hover-container' };
            }
        },
        view: defaultView,
    });
};